import { SubmitVariantResponseRequestSchema, SubmitVariantResponseResponseSchema } from './submit-variant-response.schema';
/**
 * Submit Variant Response Endpoint Contract
 * Records the caller's one-time Variant Check answer for a step recording.
 *
 * Error matrix — the rows are in the service's rejection order, which is
 * load-bearing: a replay must report "already answered", never "not
 * applicable", or a retry after a lost response would tell the responder the
 * question was never theirs.
 *
 * | Condition | Status | ErrorCode | field |
 * | --- | --- | --- | --- |
 * | Unknown recording, or the caller has no live survey row on it | 404 | `SURVEY_NOT_FOUND` | — |
 * | The caller may not update that row (CASL) | 403 | — | — |
 * | The caller's row is terminal, or a response for this recording + user at the current generation already exists (including the unique-index race), or a re-request superseded the generation the response landed at | 409 | `SURVEY_VARIANT_ALREADY_ANSWERED` | — |
 * | The check does not apply to the caller: step author, assigned User (ADR 0023), or the toggle is off with no pending nomination awaiting them | 403 | `SURVEY_VARIANT_CHECK_NOT_APPLICABLE` | — |
 * | `answer === 'different'` without a description | 400 | `SURVEY_VARIANT_DESCRIPTION_REQUIRED` | `description` |
 *
 * Both 404 arms share one code on purpose: a distinct "recording exists, but
 * not for you" would tell a caller which recordings exist.
 *
 * The 409 arms share `SURVEY_VARIANT_ALREADY_ANSWERED` because they are one
 * fact to the responder — the question is closed and the client must reload;
 * splitting them would buy a distinction no surface acts on. That also rules
 * out `SURVEY_ALREADY_DISMISSED` for the terminal-row arm: a dismissed row
 * exists only as the consequence of a `not_performed` response, so the
 * already-answered check fires on the response first and a dismissal-specific
 * code would be unreachable here.
 */ export const submitVariantResponseContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/variant-response',
    description: "Record the caller's Variant Check answer for a step recording",
    requestSchema: SubmitVariantResponseRequestSchema,
    responseSchema: SubmitVariantResponseResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: "Missing description for the 'different' answer (SURVEY_VARIANT_DESCRIPTION_REQUIRED)",
            401: 'Unauthorized - user not authenticated',
            403: 'The caller may not update that survey row (CASL, no error code), or the Variant Check does not apply to them (SURVEY_VARIANT_CHECK_NOT_APPLICABLE)',
            404: 'Unknown recording, or no live survey row for the caller (SURVEY_NOT_FOUND)',
            409: 'Already answered, or the survey row is terminal (SURVEY_VARIANT_ALREADY_ANSWERED)'
        }
    }
};

//# sourceMappingURL=submit-variant-response.contract.js.map